const Joi = require('joi')
const { emailField } = require('./fields')

const forgotPasswordSchema = Joi.object({
    email: emailField.required(),
})

module.exports = forgotPasswordSchema